import { ParsedUrlQuery } from "querystring"

/**
 * syncedState 객체의 key 값들로 URL query에서 값을 찾아 객체 형태로 반환
 * @param defaultParams 추출할 key 값들이 담긴 객체
 * @param query useRouter의 query 타입
 * @returns syncedState key와 key를 통해 URL query에서 찾은 값으로 동기화된 객체 혹은 null
 */
export default function pickMatchingParams<
  SyncState extends Record<string, string | string[]>
>(defaultParams: SyncState, query: ParsedUrlQuery): SyncState | null {
  const matchedParams = Object.entries(defaultParams).reduce(
    (acc, [key, value]) => {
      const matchedParam = query[key]
      if (!matchedParam) return acc

      /** 전달받은 객체의 값이 [] 형태라면 [] 형태로 반환 */
      const shouldBeArray = Array.isArray(value)
      const isReceivedArray = Array.isArray(matchedParam)

      const convertedParam = shouldBeArray
        ? isReceivedArray
          ? matchedParam
          : [matchedParam]
        : matchedParam

      return { ...acc, [key]: convertedParam }
    },
    {} as SyncState
  )

  return Object.keys(matchedParams).length > 0
    ? (matchedParams as SyncState)
    : null
}
